import React from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { PremiumCard, dashboardTokens } from "./dashboardStyles";

const formatBRL = (n) =>
  Number.isFinite(n) && n > 0
    ? n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 })
    : "—";

/**
 * Tabela de desempenho por corretor. Só usa métricas sustentadas pelos
 * dados reais: imóveis ativos na carteira (captador) e fechamentos pela
 * Senna (creditados ao corretor de fechamento — imovelInfo.statusInfo.corretor
 * — com fallback ao captador quando não registrado). NÃO inclui "novos 30d"
 * nem "atualizados" porque não existe createdAt/updatedAt confiável no
 * schema hoje (ver relatório).
 */
function BrokerPerformance({ brokers }) {
  if (!brokers.length) {
    return (
      <PremiumCard sx={{ p: 3 }}>
        <Typography sx={{ fontSize: "0.85rem", color: dashboardTokens.textSecondary }}>
          Nenhum corretor com imóveis vinculados.
        </Typography>
      </PremiumCard>
    );
  }

  return (
    <PremiumCard>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {["Corretor", "Ativos", "Venda", "Aluguel", "Fechamentos", "Volume fechado"].map((h, i) => (
                <TableCell
                  key={h}
                  align={i === 0 ? "left" : "right"}
                  sx={{ fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", color: dashboardTokens.textSecondary, borderBottom: `1px solid ${dashboardTokens.border}` }}
                >
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {brokers.map((b) => (
              <TableRow key={b.id} sx={{ "&:last-child td": { borderBottom: 0 } }}>
                <TableCell sx={{ fontSize: "0.84rem", color: "#1e1e1e" }}>{b.nome}</TableCell>
                <TableCell align="right" sx={{ fontSize: "0.84rem" }}>{b.ativos}</TableCell>
                <TableCell align="right" sx={{ fontSize: "0.84rem", color: dashboardTokens.textSecondary }}>{b.ativosVenda}</TableCell>
                <TableCell align="right" sx={{ fontSize: "0.84rem", color: dashboardTokens.textSecondary }}>{b.ativosAluguel}</TableCell>
                <TableCell align="right" sx={{ fontSize: "0.84rem", fontWeight: 600 }}>{b.fechamentos}</TableCell>
                <TableCell align="right" sx={{ fontSize: "0.84rem" }}>{formatBRL(b.volumeFechado)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ px: 2, py: 1.25, borderTop: `1px solid ${dashboardTokens.border}` }}>
        <Typography sx={{ fontSize: "0.7rem", color: dashboardTokens.textSecondary }}>
          "Fechamentos" credita o corretor responsável pelo fechamento quando registrado; senão, o captador do anúncio.
        </Typography>
      </Box>
    </PremiumCard>
  );
}

export default BrokerPerformance;
